export default "__VITE_PUBLIC_ASSET__375a2b62__"